export default "__VITE_ASSET__CsLS$C6E__"